module.exports = __webpack_public_path__ + "static/media/lock.294e7eaa.svg";